import React, { useState, useEffect, useRef, Fragment } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import i18n from "../../../../i18n";
import cookieManager from "../../../../utils/cookieManager";
import Select2 from "../../../utilities/Form/Select2";
import { formatCurrency, formatNumber } from "../../../utilities/Class/FormatNumber";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import { Tab } from "bootstrap/dist/js/bootstrap.min";
import { Tabs } from "react-bootstrap";
import { forEach } from "lodash";

const CashReport = (props) => {
  const {
    isProcessing,
    helperCustomerPerformance,
    dataList,
    isError,
    errorMessage,
    helperCashReport,
    setDataReport,
  } = props;

  const [fillList, setFillList] = useState(0);
  const [branchList, setBranchList] = useState([]);
  const [branchCurrent, setBranchCurrent] = useState(null);
  const [branchText] = useState(i18n.t("Select Branch"));
  const [typeCustomerList, setTypeCustomerList] = useState([]);
  const [typeCustomerCurrent, setTypeCustomerCurrent] = useState(null);
  const [typeCustomerText] = useState(i18n.t("Select Type Customer"));
  const [customerList, setCustomerList] = useState([]);
  const [customerCurrent, setCustomerCurrent] = useState(null);
  const [customerText] = useState(i18n.t("All"));
  const [periodList, setPeriodList] = useState([]);
  const [periodStartCurrent, setPeriodStartCurrent] = useState(null);
  const [periodEndCurrent, setPeriodEndCurrent] = useState(null);
  const [periodText] = useState(i18n.t("Select Period"));
  const [periodEndList, setPeriodEndList] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [typeChart, setTypeChart] = useState(2);
  const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [page, setPage] = useState(1);
  const [headeTable, setHeadeTable] = useState(false);
  const [activeKey, setActiveKey] = useState("");
  const weeks = dataList.week || [];
  console.log('STATE', { dataList });
  console.log('PROPS', props);
  const formData = useRef();

  useEffect(() => {
    if (helperCashReport?.branch?.length > 0 && helperCashReport?.workCalendar?.length > 0 && fillList === 0) {
      setBranchList(helperCashReport.branch);
      setPeriodList(helperCashReport.workCalendar);
      setFillList(1);
    }
  }, [helperCashReport, fillList]);

  useEffect(() => {
    if (weeks.length > 0) {
      setTimeout(() => {
        setActiveKey( weeks[0].week || `week-0`);
      }, 0); // delay 1 tick biar setelah render data
    }
    }, [weeks]);

  const renderError = (name) => {
    let value = "";
    if (isError) {
      if (errorMessage[name] !== undefined) {
        value = errorMessage[name][0];
      }
      Swal.close();
    }
    return value;
  }; 

  const setData = () => {
    const startDateParam =
      typeChart === 1
        ? moment(startDate).format("YYYY-MM-DD")
        : typeChart === 2
          ? periodStartCurrent?.value || ""
          : null;
    const endDateParam =
      typeChart === 1
        ? moment(endDate).format("YYYY-MM-DD")
        : typeChart === 2
          ? periodEndCurrent?.value || ""
          : null;
    const idBranch = branchCurrent?.value || "";

    let params = {
      startDate: startDateParam,
      endDate: endDateParam,
      idBranch,
      type: typeChart,

    };
    const valid = validateForm();

    if (!valid.status) {
      alertHandler("Validate Error", valid.message, "warning");
      return;
    }

    setDataReport(params);
  };

  const validateForm = () => {
    const startDateParam =
      typeChart === 1
        ? moment(startDate).format("YYYY-MM-DD")
        : typeChart === 2
          ? periodStartCurrent?.value || ""
          : null;
    const endDateParam =
      typeChart === 1
        ? moment(endDate).format("YYYY-MM-DD")
        : typeChart === 2
          ? periodEndCurrent?.value || ""
          : null;
    if (!branchCurrent) {
      return { status: false, message: "Branch harus dipilih", form: {} };
    } else if (!startDateParam || !endDateParam) {
      return { status: false, message: "Periode harus dipilih", form: {} };
    }
    return { status: true, form: { someField: "value" } };
  };

  const alertHandler = (title, message, type = "info") => {
    Swal.fire({
      title,
      text: message,
      icon: type,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "OK",
    });
  };

  // const renderError = (field) => {
  //   return `Terjadi error di ${field}`;
  // };

  const convertExcel = async (e) => {
    e.preventDefault();
    const valid = validateForm();

    if (!valid.status) {
      alertHandler("Validate Error", valid.message, "warning");
      return;
    }

    // const idBranch = branchCurrent ? branchCurrent.value : "";
    const branch = branchCurrent ? branchCurrent.label : "";
    const startDateParam =
      typeChart === 1
        ? moment(startDate).format("YYYY-MM-DD")
        : typeChart === 2
          ? periodStartCurrent?.value || ""
          : null;
    const endDateParam =
      typeChart === 1
        ? moment(endDate).format("YYYY-MM-DD")
        : typeChart === 2
          ? periodEndCurrent?.value || ""
          : null;
    const idBranch = branchCurrent?.value || "";

    const params = {
      idBranch,
      startDate: startDateParam,
      endDate: endDateParam,
      idBranch,
      type: typeChart,
    };

    try {
      Swal.fire({
        title: "Sedang memproses...",
        html: "Mohon tunggu hingga file siap diunduh",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      const token = cookieManager.getUserToken();
      const response = await axios({
        headers: { Authorization: `Bearer ${token}` },
        url: process.env.REST_URL + "report/cash-report-excel",
        method: "POST",
        data: params,
        responseType: "blob",
      });
      console.log(response)
      if (response && response.status === 200 && response.data) {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Convert Excel",
          text: "Download berhasil",
          timer: 1500,
          showConfirmButton: false,
        });
        const blobUrl = window.URL.createObjectURL(response.data);

        const link = document.createElement("a");
        link.style.display = "none";
        link.href = blobUrl;
        link.setAttribute(
          "download",
          `${branch} - Rekap Biaya Harian.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Convert Excel",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Download gagal, coba lagi",
        confirmButtonText: "OK",
      });
    } finally {
      // setLoading(false);
    }
  };

  const changeData = ({ keyFill, type = null, value = null, callback = () => { } }) => {
    let url = null;
    let params = {};
    const token = cookieManager.getUserToken();

    switch (type) {
      case "getCustomer":
        url = process.env.REST_URL + "helper/get-list-customer";
        if (branchCurrent == null) type = null;
        console.log('msuk')
        params = {
          branch: branchCurrent?.value || null,
          tipe: value || typeCustomerCurrent?.value || null,
        };
        console.log('params', params)
        break;
      default:
        break;
    }

    if (type != null) {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        url,
        responseType: "json",
        params,
      })
        .then((response) => {
          if (response?.status === 200 && response.data) {
            callback(response.data.result);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // const renderList = () => {
  //   if (dataList?.list?.length > 0) {
  //     return dataList.list.map((row, i) => (
  //       <tr className="border" key={i}>
  //         <td className="search-td" style={{minWidth:"180px"}} >{row.name_customer}</td>
  //         <td className="search-td">{row.district}</td>
  //         {/* <td className="search-td">{row.week}</td>
  //         <td className="search-td">{row.month}</td> */}
  //         {dataList.range.map((week) =>
  //               items.map((item) => {
  //                 const value =
  //                   salesMap[cust.idCustomer]?.[week]?.[item.id_item] || "";
  //                 return <td key={`${cust.idCustomer}-${week}-${item.id_item}`}>{value}</td>;
  //               })
  //             )}
  //         {/* {row.value?.map((val, idx) => {
  //           const found = val.detail.find(
  //               u => parseInt(u.id) === parseInt(header.idUnit)
  //           );
  //           <Fragment key={idx}>
  //             <td className="search-td" style={{ textAlign: "right" }}>
  //               {val.volume_format}
  //             </td>
  //           </Fragment>
  //         })} */}
  //       </tr>
  //     ));
  //   }
  //   return null;
  // };

  const renderBarang = (data) => {
    const barang = dataList.report;
    const sales = dataList.sales;
    const type = dataList.type;
    return (
      <Fragment>
        <br />
        <br />
        <table
          className="search-table"
          style={{ borderBottom: "1px solid #eff2f5", fontSize: '14px', marginTop: '10px', width: '100%', tableLayout: "auto" }}
        >
          <thead className="" style={{
            fontWeight: 'bolder',
            fontSize: '14px',
            background: '#027D8A',
            color: 'white',
            textAlign: 'center',
          }}>
            <tr>
              <th className="search-th" rowSpan={2} style={{ width: "20%" }}>{i18n.t("Brand")}</th>
              <th className="search-th" rowSpan={2} style={{ width: "10%" }} >{i18n.t("Total Volume")}</th>
              {sales.length > 0 &&
                sales.map((sale, i) => (
                  <th className="search-th" colSpan={2} style={{ width: `${30 / sales.length}%` }} key={i}>
                    {sale.name}
                  </th>
                ))
              }
              <th className="search-th" rowSpan={2} style={{ width: "10%" }}>{i18n.t("Total (Rp)")}</th>
            </tr>
            <tr>  
              {sales.length > 0 &&
                sales.flatMap((sale, i) => (
                  type.map((payment,j)=>(
                    <th className="search-th" style={{ width: '5%' }} key={"payment"+i+j}>{i18n.t(payment)}</th>
                  ))
                ))
              }
            </tr>
          </thead>
          <tbody className="">
            {barang?.length > 0 ?
              barang.map((item, i) => {
                let totalPerRow = 0;
                return (
                  <tr>
                    <td className="search-td" style={{ textAlign: "left", fontWeight: "bold" }}>{i18n.t(item.name)}</td>
                    {item.stock_by_week
                      .filter(r => r.week === data.week)
                      .map((weekData, j) => (
                        <>
                          <td
                            key={j}
                            className="search-td"
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          >
                            {weekData.total_stock >= 0 ? formatNumber(weekData.total_stock) : ('('+(formatNumber((-1)*weekData.total_stock)+')'))}
                          </td>
                          {
                            sales.flatMap((sale, i) => {
                              const saleData = weekData?.sales.find(s => s.id === sale.id);
                              return type.map((payment,j)=>{
                                  totalPerRow += saleData?.[payment]??0;
                                  return (<td className="search-td" style={{ width: '5%', textAlign:"right" }} key={"payment"+i+j}>Rp. {formatNumber(saleData?.[payment]) ?? 0}</td>)
                            })
                            })  
                          }
                        
                        </>

                      ))}
                    <td
                      className="search-td"
                      style={{
                        minWidth: "180px",
                        textAlign: "right",
                        fontWeight: "bold",
                        background: "#fafafa",
                      }}
                    >
                      Rp. {totalPerRow !== 0 ? formatNumber(totalPerRow) : "-"}
                    </td>

                  </tr>

                );
              })


              : null
            }
          </tbody>
          <tfoot>
            <tr>
              <td
                className="search-td"
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#f1f1f1",
                }}
              >
                {i18n.t("TOTAL")}
              </td>

              {/* Total volume semua barang */}
              <td
                className="search-td"
                style={{ textAlign: "center", fontWeight: "bold", background: "#f1f1f1" }}
              >
                {formatNumber(
                  barang.reduce((sum, item) => {
                    console.log('SUM',sum)
                    const weekData = item.stock_by_week.find((r) => r.week === data.week);
                    return (parseInt(sum) || 0 )+ (weekData?.total_stock ?? 0);
                  }, 0)
                )}
              </td>

              {/* Total per kolom sales */}
              {sales.map((sale, idx) => {
               return  type.map((payment, j)=>{
                const totalPerSale = barang.reduce((sum, item) => {
                  const weekData = item.stock_by_week.find((r) => r.week === data.week);
                  const saleData = weekData?.sales.find((s) => s.id === sale.id);
                  {/* let hasil = 0;
                  
                  type.map((payment,j)=>{
                      hasil += saleData?.[payment];
                  }) */}
                  

                  return (parseFloat(sum) || 0) + (saleData?.[payment]);
                }, 0);
                {/* return type.map((payment,j)=>{ */}
                  return (
                    <td
                      key={idx}
                      className="search-td"
                      style={{
                        textAlign: "right",
                        fontWeight: "bold",
                        background: "#f1f1f1",
                      }}
                    >
                      Rp. {formatNumber(totalPerSale)}
                    </td>
                  );
                })
              })}

              {/* Total keseluruhan semua sales */}
              <td
                className="search-td"
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                  background: "#f1f1f1",
                }}
              >
                Rp.{" "}
                {formatNumber(
                  barang.reduce((grand, item) => {
                    const weekData = item.stock_by_week.find((r) => r.week === data.week);
                    const sumSales = weekData?.sales.reduce((a, s) => a + (s.Cash ?? 0) + (s.Credit ?? 0), 0) ?? 0;
                    return grand + sumSales;
                  }, 0)
                )}
              </td>
            </tr>
          </tfoot>
        </table>
      </Fragment>
    );
  }


  const renderList = (data) => {
    const biaya = dataList.biaya || [];
    const coa2 = dataList.coa2 || [];
    const result = dataList.result || [];
    let totalBawah = Array(data?.day?.length).fill(0);
    return (
      <Fragment>
        <table
          className="search-table"
          style={{ borderBottom: "1px solid #eff2f5", fontSize: '14px', marginTop: '10px', width: '100%', tableLayout: "auto" }}
        >
          <thead className="" style={{
            fontWeight: 'bolder',
            fontSize: '14px',
            background: '#027D8A',
            color: 'white',
            textAlign: 'center',
          }}>
            <tr>
              <th rowSpan={2} colSpan={2} className="search-th" style={{ width: "40%" }}>
                {i18n.t("Biaya")}
              </th>

              {data.day.length > 0 &&
                data.day.map((days, i) => (
                  <th key={i} className="search-th" style={{ width: "2%" }}>
                    {i18n.t(days.day)}
                  </th>
                ))}

              <th rowSpan={2} colSpan={2} className="search-th" style={{ width: "20%" }}>
                {i18n.t("Total")}
              </th>
            </tr>
            <tr>
              {data.day.length > 0 &&
                data.day.map((days, i) => (
                  <th key={i} className="search-th" style={{ width: "2%" }}>
                    {i18n.t(days.date)}
                  </th>
                ))}


            </tr>
          </thead>

          <tbody className="">
            {coa2.length > 0 && 
              coa2.map((coa,p)=>(
                <>
                  <tr style={{ background: '#CCFFE5' }}>
                    <td className="search-td" colSpan={"9"} style={{ width: "20%",  textAlign: "left", fontWeight:'bold' }}>{i18n.t(coa.name)}</td>

                  </tr>

                {biaya?.length > 0 &&
                biaya.map((item, i) => {
                  let totalSamping = 0;
                  if(item.parent === coa.id){
                  return (
                    <tr>
                      <td colSpan={"2"} className="search-td" style={{ width: "20%", textAlign: "left" }}>{i18n.t(item.name)}</td>
                      {/* <td></td> */}
                      {data?.day?.length > 0 &&
                        data.day.map((dayItem, j) => {
                          const found = result.find(r => r.id === item.id);
                          const val = found?.tanggal?.[dayItem.format] != 0 ?
                            formatNumber(found?.tanggal?.[dayItem.format]) : '-';
                          totalSamping += found?.tanggal?.[dayItem.format] ?? 0;
                          totalBawah[j] += found?.tanggal?.[dayItem.format] ?? 0;
                          return (
                            <td
                              key={j}
                              className="search-td"
                              style={{textAlign: "right", width: "8%" }}
                            >
                             Rp. {val}
                            </td>
                          );
                        })}
                      <td
                        key={'total' + i}
                        className="search-td"
                        style={{  textAlign: "right", fontWeight: "bold" }}
                      >
                        Rp. {(totalSamping != 0 ? formatNumber(totalSamping) : '-')}
                      </td>
                    </tr>
                  );
                  }
                })}
                </>
              ))
            }
            
            <tr style={{ background: '#CCFFE5' }}>
              <td colSpan={"2"} className="search-td" style={{  textAlign: "center", fontWeight: "bold", }}>
                {i18n.t("Total")}
              </td>
              {totalBawah.map((t, j) => (
                <td
                  key={"totalBawah" + j}
                  className="search-td"
                  style={{  textAlign: "right", fontWeight: "bold" }}
                >
                  Rp. {t !== 0 ? formatNumber(t) : ""}
                </td>
              ))}
              <td
                className="search-td"
                style={{  textAlign: "right", fontWeight: "bold" }}
              >
              Rp. {formatNumber(totalBawah.reduce((a, b) => a + b, 0))}
              </td>
            </tr>
          </tbody>
        </table>
        {renderBarang(data)}
      </Fragment>

    );

  };

  

  const renderTable = () => {
    const weeks = dataList.week || [];
    if (!isError) {
      return (
        <div>
          <div id="html-dist"></div>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              textAlign: "center",
              marginTop: "5px",
            }}
          >
            {i18n.t("Daily Cost Summary")}
          </div>

          <Tabs defaultActiveKey={weeks[0].week} id={'tabs'} className="mt-3" onSelect={(k) => setActiveKey(k)}>
            {weeks.map((week, i) => (
              <Tab
                key={week.week}
                eventKey={week.week || `week-${i}`}
                title={i18n.t("Week") + " " + `${week.week}`}
              >
                <Fragment>{renderList(week)}</Fragment>
              </Tab>


            ))}

          </Tabs>

        </div>
      );
    }
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "5px",
        }}
      >
        {i18n.t("DATA NOT FOUND")}
      </div>
    );
  };



  //Render Header
  return (
    <Fragment>
      <div id="invoice-page">
        {/* <Breadcrumbs 
          url={} 
          tools={false} 
        /> */}
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >
          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-body pt-8">
                <div className="row">
                  {typeChart === 2 && (
                    <Fragment>
                      <div className="col-sm-2 mt-3">
                        <Select2
                          name={"Period"}
                          isClearable
                          onChange={(e) => {
                            setPeriodEndList([]);
                            setPeriodEndCurrent("");
                            setPeriodStartCurrent(e);
                            
                            if (e) {
                              const index = periodList.findIndex(
                                (item) => item.value === e.value
                              );
                              const newList = periodList.slice(index, index + 5);
                              setPeriodEndList(newList);
                            }
                          }}
                          options={periodList}
                          value={periodStartCurrent}
                          placeholder={periodText}
                          title={i18n.t("Week Period")}
                        />
                      </div>
                      <div style={{ width: "35px" }} className="col-sm-1 mt-11">
                        {i18n.t("To")}
                      </div>
                      <div className="col-sm-2 mt-6">
                        <Select2
                          title={""}
                          name={"periodCurrent"}
                          isClearable
                          onChange={(e) => setPeriodEndCurrent(e)}
                          // options={periodList}
                          options={periodEndList}
                          value={periodEndCurrent}
                          placeholder={periodText}
                        />
                      </div>
                    </Fragment>
                  )}

                  <div className="col-sm-2 mt-3">
                    <Select2
                      isClearable
                      onChange={(e) => {
                        setBranchCurrent(e);
                        if (e == null) {
                          setCustomerList([]);
                          setCustomerCurrent("");
                        } else {
                          setLoadingCustomer(true);

                        }
                      }}
                      name={"idBranch"}
                      options={branchList}
                      value={branchCurrent}
                      placeholder={branchText}
                      title={i18n.t("Branch")}
                    />
                    <div className="fv-plugins-message-container invalid-feedback">
                      {renderError("idBranch")}
                    </div>
                  </div>

                  <div className="row ml-5">
                    <div className="col-md-9 mt-3 mb-3">
                      <Button
                        onClick={() => {
                          setPage(1);
                          setData();
                          setHeadeTable(true);
                        }}
                        variant="success"
                        className="btn btn-md btn btn-success m-1"
                      >
                        <FontAwesomeIcon icon={faEye} /> {i18n.t("  Generate")}
                      </Button>
                      <button className="btn btn-secondary dropdown-toggle m-1" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {i18n.t("Convert")}
                      </button>
                      <div className="dropdown-menu dropdown-menu-area" aria-labelledby="dropdownMenuButton">
                        {/* <a className="dropdown-item" onClick={()=>this.convertPdf()}><FontAwesomeIcon icon={faFilePdf}></FontAwesomeIcon>  {i18n.t("PDF")}</a>  */}
                        <a className="dropdown-item " href="#" onClick={convertExcel}><FontAwesomeIcon icon={faFileExcel}></FontAwesomeIcon>  {i18n.t("Excel")} </a>

                      </div>
                    </div>
                  </div>
                </div>

                {headeTable && (
                  <div className={isProcessing ? "table-loading" : ""}>
                    {!isProcessing ? (
                      <Fragment>
                        {renderTable()}

                      </Fragment>
                    ) : (
                      <div className="table-loading-message">
                        <div className="spinner-border text-primary text-center ms-3 clearfix"></div>
                        <div className="text-center">{i18n.t("Loading")}</div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CashReport;
